import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Card, CardBody } from "reactstrap";

import dummyImg from "../../assets/images/users/user-dummy-img.jpg";

import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Mousewheel } from "swiper";

const CommentaireSlider = ({ commentaires = [] }) => {
  // console.log("commentaires component: ", commentaires);
  function formatDate(date) {
    const dateObject = new Date(date).toLocaleDateString("fr-FR", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      timeZoneName: "short",
    });
    return dateObject;
  }

  return (
    commentaires.length > 0 && (
      <Swiper
        direction={"vertical"}
        slidesPerView={2}
        spaceBetween={10}
        mousewheel={true}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Mousewheel]}
        className="mySwiper vertical-swiper"
        style={{ height: "250px" }}
      >
        {commentaires.map(
          (data, key) =>
            data.commentaire && (
              <SwiperSlide key={key}>
                <Card className="border border-dashed shadow-none">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-shrink-0 avatar-sm">
                        <div className="avatar-title bg-light rounded">
                          <img src={dummyImg} alt="" height="30" />
                        </div>
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <div>
                          <p className="text-muted mb-1 fst-italic text-truncate-two-lines">
                            {data.commentaire}
                          </p>
                          <div className="fs-14 align-middle text-secondary">
                            {formatDate(data.date_course)}
                          </div>
                        </div>
                        <div className="text-end mb-0 text-muted">
                          - Par
                          <cite title="Source Title">
                            {data.last_name_client +
                              " " +
                              data.first_name_client}
                          </cite>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </SwiperSlide>
            )
        )}
      </Swiper>
    )
  );
};

export default CommentaireSlider;
